<template>
  <van-dialog 
    v-model="isVisible"
    className="dialog"
    theme="round"
    @confirm="onConfirm">
    <div class="dialog-title" slot="title">
      <div class="dialog-title-txt">充值</div>
      <van-icon class="close-icon" name="cross" size="22" @click="onClose"/>
    </div>
    <div class="tips">
      <van-icon name="warning-o" />
      微信充值将会收取一定的手续费
    </div>
    <div class="dialog-content">
      <van-field  v-model="title" label="充值类型"  readonly />
      <van-field type="number" v-model="rechargeAmount" label="充值金额"  placeholder="请输入(两位小数)" @blur="checkFeeValid">
        <span slot="right-icon">元</span>
      </van-field>
    </div>
  </van-dialog>
</template>

<script>
import {round2Places} from '@/utils/utils'
import {wxPay} from '@/utils/wxPay'
export default {
  name: 'RechargeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '现金红包'
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    is365() {
      return this.$cache.is365()
    }
  },
  data() {
    return {
      rechargeAmount: ''
    }
  },
  methods: {
    checkFeeValid() {
      this.rechargeAmount = this.rechargeAmount < 0.3 ? 0.3 : round2Places(this.rechargeAmount);
    },
    onConfirm() {
      if (!this.rechargeAmount || +this.rechargeAmount <= 0) {
        this.$toast('充值金额不能为空和0');
        return;
      }

      const params = {
        flag: this.is365 ? 2 : 1,
        activityId: this.$route.query.activityId,
        rechargeAmount: +this.rechargeAmount
      };
      let requery = 'rechargeToRedPacket'
      switch(this.title) {
        case '现金红包' :
          requery = 'rechargeToRedPacket'
         break;
        case '裂变佣金' :
          requery = 'fissionWalletRecharge'
          break;
        case '抽奖' :
          requery = 'lotteryWalletRecharge'
          break;
        default :
          break
      }
      this.$api.activityMgmt[requery](params)
        .then(async ({data}) => {
          if (data.orderNo) {
            data.source = 'recharge'
            await wxPay(data).then(_ => {
              this.$emit('success')
              this.onClose();
            })
          }
        });
    },
    onClose() {
      this.isVisible = false;
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog
  border-radius: 12px
  .dialog-title
    position relative
    &-text
      text-align: center
    .close-icon
      display: inline-block
      position absolute
      right 10px
      top 0
    
  .dialog-content
    >>> .van-field .van-field__value input
      color #FF6B31
  >>> .van-dialog__header
    padding 20px 0
  >>> .van-dialog__footer button
    margin 15px 15px 20px
    padding 10px 0
    border-radius 25px
    height: auto
    line-height 1
    color #fff
    background: linear-gradient(#FF8820, #FF6B31)

  .field-item
    // margin 15px 0
    display: flex
    justify-content: space-between
    align-items: center
    padding 10px 16px
    font-size 14px
    background-color: #fff
    border-radius: 8px
    &-title
      color #323233
      // font-weight 600
  .tips {
    color: #999;
    font-size: 12px;
    margin-left:20px;
  }
</style>